
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/control.vue';
    import movil from './movil/control.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
